import { client } from "./index";

// Discount coupons. siteId: a store's coupons for its shoppers; null: Ownezzy's coupons on website plans (Super Admin)
const base = (siteId) => (siteId ? `/admin/sites/${siteId}/coupons` : "/admin/coupons");
export const getCoupons = (siteId) => client.get(base(siteId));
export const createCoupon = (siteId, payload) => client.post(base(siteId), payload);
export const updateCoupon = (siteId, couponId, payload) => client.put(`${base(siteId)}/${couponId}`, payload);
export const deleteCoupon = (siteId, couponId) => client.delete(`${base(siteId)}/${couponId}`);
// What an Ownezzy coupon takes off Pay now (store owners)
export const checkPlanCoupon = (siteId, params) => client.get(`/admin/sites/${siteId}/coupon`, { params });
